const breakpoints: { mobile: string; noHover: string } = {
  mobile: `@media (max-width: ${768}px)`,
  noHover: `@media (hover: none)`
};
export default breakpoints;
